import { Talep } from './talep';
import { TeklifKalem } from './teklif-kalem';
import { Cari } from './cari';
import { Irsaliye } from './irsaliye';
import { SiparisOnaySeviye } from './siparis-onay-seviye';
import { Teklif } from './teklif';
import { SiparisKalem } from './siparis-kalem';

export class Siparis {

  public static DURUM_REDDEDILDI = -1;
  public static DURUM_ONAY_BEKLIYOR = 0;
  public static DURUM_ONAYLANDI = 1;
  public static DURUM_IRSALIYE_OLUSTURULDU = 2;

  id: number;
  durum: number;
  siparisNotu: string;
  talepId: number;
  cariId: number;
  olusturmaTarihi: string;
  private pTeklifKalemler: TeklifKalem[];
  private pIrsaliyeler: Irsaliye[];
  private pSiparisKalemler: SiparisKalem[];

  talep: Talep;
  cari: Cari;
  siparisOnaySeviye: SiparisOnaySeviye;
  siparisOnaySeviyeId: number;
  toplamSiparisMiktar: number;
  toplamIrsaliyeMiktar: number;
  teklif: Teklif;
  isKapatildi: boolean;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.talep != null) {
      this.talep = new Talep(obj.talep);
    }
    if (obj.cari != null) {
      this.cari = new Cari(obj.cari);
    }
  }

  get durumText(): string {
    if (this.durum != null) {
      switch (this.durum) {
        case Siparis.DURUM_ONAY_BEKLIYOR:
          return this.siparisOnaySeviye?.kullaniciGrup?.isim + ' Onayında';
        case Siparis.DURUM_ONAYLANDI:
          return 'Onaylandı';
        case Siparis.DURUM_REDDEDILDI:
          return 'Reddedildi';
        case Siparis.DURUM_IRSALIYE_OLUSTURULDU:
          return 'İrsaliye Oluşturuldu';
      }
    }
    return '';
  }

  get olusturmaTarihiText(): string {
    if (this.olusturmaTarihi != null) {
      const date = new Date(this.olusturmaTarihi);
      return date.toLocaleString();
    }
    return '';
  }

  public get teklifKalemler(): TeklifKalem[] {
    return this.pTeklifKalemler;
  }

  public set teklifKalemler(list: TeklifKalem[]) {
    if (list != null) {
      this.pTeklifKalemler = list.map(t => new TeklifKalem(t));
    }
  }

  public get siparisKalemler(): SiparisKalem[] {
    return this.pSiparisKalemler;
  }

  public set siparisKalemler(list: SiparisKalem[]) {
    if (list != null) {
      this.pSiparisKalemler = list.map(t => new SiparisKalem(t));
    }
  }

  public get irsaliyeler(): Irsaliye[] {
    return this.pIrsaliyeler;
  }

  public set irsaliyeler(list: Irsaliye[]) {
    if (list != null) {
      this.pIrsaliyeler = list.map(t => new Irsaliye(t));
    }
  }
}
